/* eslint-disable @typescript-eslint/no-var-requires */
import { TheWestSection } from '@news-mono/common'
import { metrics, ResponsivePictureLayout } from '@news-mono/component-library'
import { StaticRoutes, Topic } from '@news-mono/web-common'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'
import { getTopicSponsor } from '../../topic/get-topic-sponsor'

const bannerDesktopX2 = require<string>('./assets/YourStoryOurStory-1220x150px@2x.jpg')

const bannerDesktopX1 = require<string>('./assets/YourStoryOurStory-1220x150px.jpg')

const bannerTabletX2 = require<string>('./assets/YourStoryOurStory-738x57px@2x.jpg')

const bannerTabletX1 = require<string>('./assets/YourStoryOurStory-738x57px.jpg')

const bannerMobileX2 = require<string>('./assets/YourStoryOurStory-411x93px@2x.jpg')

const bannerMobileX1 = require<string>('./assets/YourStoryOurStory-411x93px.jpg')

const socialImage = require('./assets/YourStoryOurStory-social-1224x688px.jpg')

export const getYourStoryOurStorySocialImageMeta = [
    {
        property: 'og:image',
        content: socialImage,
    },
    { name: 'twitter:image', content: socialImage },
    {
        property: 'og:image:height',
        content: '688',
    },
    {
        property: 'og:image:width',
        content: '1224',
    },
]

const topic: Topic = {
    id: 'features/your-story-our-story',
    metadata: {},
    seoTitle: 'Your Story, Our Story',
    title: 'Your Story, Our Story',
    seoDescription: 'Charting the history of WA immigration',
    parent: {
        id: 'features',
        metadata: {},
        seoTitle: 'Features',
        title: 'Features',
    },
}

export const getYourStoryOurStoryRouteInfo: StaticRoutes<TheWestSection> = {
    '/features/your-story-our-story': ({ getAdTargeting, config }) => {
        const canonicalUrl = config.publicUrl + '/features/your-story-our-story'

        return {
            kind: 'page',
            heading: 'Your Story, Our Story',
            pageType: 'topic',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: topic.title,
                description: topic.seoDescription,
                link: [{ rel: 'canonical', href: canonicalUrl }],
                meta: getYourStoryOurStorySocialImageMeta,
            },
            socialMeta: {
                title: topic.seoTitle,
                description: topic.seoDescription,
            },
            adTargeting: getAdTargeting(
                'home',
                'default',
                'features/your-story-our-story',
            ),
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'box',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        verticalGutters: ['outerMargin', 'unset'],
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'breaking-news',
                                props: {
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'breaking-news',
                                        offset: 0,
                                        pageSize: 1,
                                    },
                                },
                            }),
                            layout.component({
                                type: 'breaking-news-promo-strap',
                                props: {
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'breaking-news-promo-strap',
                                        offset: 0,
                                        pageSize: 1,
                                    },
                                },
                            }),
                            layout.component({
                                type: 'breadcrumb',
                                props: {
                                    topic,
                                    sponsor: getTopicSponsor(topic),
                                    enableHeaderTag: true,
                                },
                            }),
                        ],
                    },
                }),
                layout.composition({
                    type: 'thor',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'image-banner',
                                props: {
                                    defaultSrc: bannerDesktopX2,
                                    verticalGutters: ['unset', 'md'],
                                    altText:
                                        'Your Story, Our Story - Charting the history of WA immigration',
                                    sources: [
                                        {
                                            breakpoint: 'md',
                                            src: [
                                                {
                                                    src: bannerDesktopX2,
                                                    density: '2x',
                                                },
                                                {
                                                    src: bannerDesktopX1,
                                                    density: '1x',
                                                },
                                            ],
                                        },
                                        {
                                            breakpoint: 'xs',
                                            src: [
                                                {
                                                    src: bannerTabletX2,
                                                    density: '2x',
                                                },
                                                {
                                                    src: bannerTabletX1,
                                                    density: '1x',
                                                },
                                            ],
                                        },
                                        {
                                            src: [
                                                {
                                                    src: bannerMobileX2,
                                                    density: '2x',
                                                },
                                                {
                                                    src: bannerMobileX1,
                                                    density: '1x',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            }),
                            layout.nestedComposition({
                                type: 'janus',
                                props: {
                                    layoutRatio: '3:1',
                                    stretchColumns: true,
                                    verticalSpacing: 'xl',
                                },
                                contentAreas: {
                                    left: [
                                        layout.component({
                                            type: 'sierra',
                                            props: {
                                                fixedRatios: ['16:9'],
                                                heroImageLayout:
                                                    ResponsivePictureLayout.ObjectFitContain,
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                    maxBreakpoint: 'md',
                                                },

                                                cardLayout: ['hero-video'],
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: 'your-story-our-story',
                                                    offset: 0,
                                                    pageSize: 1,
                                                },
                                            },
                                        }),
                                    ],
                                    right: [
                                        layout.component({
                                            type: 'tw-subscribe-promo-card',
                                            props: {},
                                        }),
                                    ],
                                },
                            }),
                            layout.component({
                                type: 'lima',
                                props: {
                                    verticalSpacing: 'xl',
                                    fontScale: 1.2,
                                    fixedRatios: ['16:9'],
                                    initialColumns: 1,
                                    intermediateColumns: 2,
                                    finalColumns: 4,
                                    hasBackground: true,
                                    sectionHeader: {
                                        heading: 'Read Their Stories',
                                    },

                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'your-story-our-story',
                                        offset: 1,
                                        pageSize: 8,
                                    },
                                },
                            }),

                            ...billboardLeaderboardMrec('two'),
                        ],
                    },
                }),
            ],
        }
    },
}
